define('GameDayCore/GDModel/ValueObjects/Gamecenter/TicketLinks',['require','exports','module','../ValueObjectFactory'],function(require, exports, module) {
	var VO = require('../ValueObjectFactory');

	VO.create(TicketLinks);

	function TicketLinks($data) {
		var vo = VO.ensureVO(this, TicketLinks),
			data = $data;

			vo.ticketedEvents = data.events.game;
	}

	return TicketLinks;
});
